import { render, staticRenderFns } from "./IntegrationSetup.vue?vue&type=template&id=985b200e"
import script from "./IntegrationSetup.vue?vue&type=script&lang=js"
export * from "./IntegrationSetup.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSetup.vue?vue&type=style&index=0&id=985b200e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports